import emailjs from '@emailjs/browser';

export const sendMail = (values: { [key: string]: string }) => emailjs.send('postica_renovation', 'postica_renovation_templ', values, 'wlkfwc_UwuuT6QTq4')